import { render, staticRenderFns } from "./FormInventarioProducto.vue?vue&type=template&id=0a102659&"
import script from "./FormInventarioProducto.vue?vue&type=script&lang=js&"
export * from "./FormInventarioProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports